<template>

  <div class="container-fluid mt-5 page-padding margin_80_35">
    <!-- <div class="row  faq-heading">
      <div class="col-12">
        <h2>Frequently Asked Questions</h2>
      </div>
    </div> -->
    <div class="row pt-3">
      <div class="col-lg-12 col-md-12" id="faq" v-if="faqList">
        <div ref="faq-list-display" class="row faq-list-display">
          <div id="faq-cat-container" class="col-3">
            <div class="list-group faq-list-tab" id="list-tab" role="tablist">
              <div :ref="'faq-cat-tab-' + category.Id" v-for="(category, index) in categorylist" :key="index" :class="{ active: selectedParentCategory === category.Id }"
                class="p-0 cat-container-item cursor-pointer list-group-item list-group-item-action"
                :id="'faq-cat-tab-' + category.Id"  role="tab"
                aria-controls="">
                <ul class="list-group tab-parent-category-item">
                  <li @click="scrollToTop(), setSelectedParentCategory(category.Id)" class="list-group-item rounded-0" :class="{ active: selectedParentCategory === category.Id }">{{ category.Title }}</li>
                </ul>
                  <ul v-if="category.ChildCategory.length > 0 && selectedParentCategory === category.Id" class="list-group tab-sub-category">
                    <li @click="scrollToTop(), setSelectedCategory(childCategory.Id)" v-for="(childCategory, index) in category.ChildCategory" :key="index" 
                    class="text-dark cursor-pointer list-group-item rounded-0 tab-sub-category-item"
                    :class="{ active: selectedCategory === childCategory.Id }"
                    ><span class="">{{ childCategory.Title }}</span></li>
                  </ul>
              </div>
            </div>
          </div>
          <div id="faq-container" class="col-9 faq-container">
            <div class="tab-content" id="nav-tabContent">
              <div class="accordion w-100 accordionBigScreenView" :id="'accordionBigScreenView' + selectedCategory">
                  <div :ref="'faq-' + faq.Id" v-for="faq in filteredFaqList" :key="faq.Id" :id="'faq-' + faq.Id"
                    class="card">
                    <div class="card-header p-0" :id="'ABSVheading' + faq.Id">
                      <h5 :ref="'faq-inner-' + faq.Id" class="cursor-pointer acc-item-padding mb-0 w-100 d-flex justify-content-between" data-toggle="collapse" :data-target="'#ABSVcollapse' + faq.Id"
                          aria-expanded="true" :aria-controls="'ABSVcollapse' + faq.Id">
                        <span class="p-0">{{ faq.Question }}</span>
                      </h5>
                    </div>
                    <div :id="'ABSVcollapse' + faq.Id" class="collapse" :aria-labelledby="'ABSVheading' + faq.Id" :data-parent="'#accordionBigScreenView'+ selectedCategory">
                      <div class="card-body">
                        <span @click="onTagClick(item)" v-for="(item, index) in faq.KeyWordList" :key="index"
                          class="badge badge-pill badge-secondary mr-1 cursor-pointer">#{{ item }}</span>
                        <p class="pt-2" v-html="faq.Answer"></p>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!filteredFaqList">
                  <p class="">No FAQ found in this category!</p>
                </div>
              <div v-for="(category, index) in categorylist" :key="index" class="tab-pane fade show"
                :class="{ active: index === 0 }" :id="'faq-cat-' + category.Id" role="tabpanel"
                :aria-labelledby="'faq-cat-tab-' + category.Id">
              </div>
            </div>
          </div>
        </div>
        <div class="row mx-2 faq-accordion-display">
          <div class="accordion w-100" id="accordionFAQ">
            <div v-for="(category, index) in categorylist" :key="index" class="card">
              <div class="card-header" :id="'heading' + category.Id">
                <h2 class="mb-0 w-100">
                  <button :ref="'accordion-btn-' + category.Id" :id="'accordion-btn-' + category.Id"
                    class="btn btn-block text-left" type="button" data-toggle="collapse"
                    :data-target="'#collapse' + category.Id" aria-expanded="true"
                    :aria-controls="'collapse' + category.Id">
                    {{ category.Title }}
                  </button>
                </h2>
              </div>
              <div :id="'collapse' + category.Id" class="collapse" :class="{ show: index === 0 }"
                :aria-labelledby="'heading' + category.Id" data-parent="#accordionFAQ">
                <div class="card-body faq-container">
                  <div class="accordion w-100 accordionBigScreenView" :id="'accordionSmallScreenView' + category.Id">
                  <div :ref="'faq-acc-' + faq.Id" v-for="faq in faqListByParentCategory[category.Id]" :key="faq.Id" :id="'faq-acc-' + faq.Id"
                    class="card">
                    <div class="card-header p-0" :id="'ASSVheading' + faq.Id">
                      <h5 :ref="'faq-acc-inner-' + faq.Id" class="cursor-pointer acc-item-padding mb-0 w-100 d-flex justify-content-between" data-toggle="collapse" :data-target="'#ASSVcollapse' + faq.Id"
                          aria-expanded="true" :aria-controls="'ASSVcollapse' + faq.Id">
                        <span class="p-0">{{ faq.Question }}</span>
                      </h5>
                    </div>
                    <div :id="'ASSVcollapse' + faq.Id" class="collapse" :aria-labelledby="'ASSVheading' + faq.Id" :data-parent="'#accordionSmallScreenView'+ category.Id">
                      <div class="card-body">
                        <span @click="onTagClick(item)" v-for="(item, index) in faq.KeyWordList" :key="index"
                          class="badge badge-pill badge-secondary mr-1 cursor-pointer">#{{ item }}</span>
                        <p class="" v-html="faq.Answer"></p>
                      </div>
                    </div>
                  </div>
                  <div v-if="!faqListByParentCategory[category.Id]">
                    <p class="mb-0">No FAQ found in this category!</p>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /row -->
  </div>
</template>

<script>
import lodash from 'lodash'
import FAQService from '../services/faq-service'
import CategoryService from '../services/category-service'

export default {
  name: 'FaqDetails',
  data() {
    return {
      selectedcategory: { Title: 'All Category', Id: 0 },
      categorylist: [],
      childCategoryList: [],
      searchText: null,
      filteredFaqList: [],
      faqList: [],
      faqListByParentCategory: [],
      publishStatus: true,
      selectedCategory : 0,
      selectedParentCategory : 0
    }
  },
  mounted() {
    this.getCategory()
  },
  watch: {
    $route() {
      if (this.categorylist && this.faqList) {
        this.selectCategory()
      }
    }
  },
  components: {},
  methods: {
    getCategory() {
      CategoryService.getcategoryList().then((response) => {
        if(response.data.Status && response.data.Object){
          this.categorylist = response.data.Object.categories
          if(this.categorylist.length > 0){
            this.childCategoryList = lodash.filter(this.categorylist, (item)=>{return item.ParentId > 0})
            this.categorylist = lodash.filter(this.categorylist, { 'ParentId': 0 })
            this.fetchFAQList()
          }
        } else {
          this.categorylist = []
          this.childCategoryList = []
        }
      }),
      (error) => {
        console.log(error)
      }
    },
    fetchFAQList() {
      // console.log(location.pathname.split('/').slice(-1)[0].replace(/^\/|\/$/g, ''))
      this.faqList = []
      this.filteredFaqList = []
      FAQService.getFilteredFaqList(this.publishStatus, this.selectedcategory.Id, this.searchText).then(
        response => {
          if (response.data.Status) {
            // this.faqList = lodash.orderBy(response.data.Object.faqs, ['CategoryTitle'], ['asc'])
            this.faqList = lodash.groupBy(response.data.Object.faqs, 'SubCategoryId')
            this.faqListByParentCategory = lodash.groupBy(response.data.Object.faqs, 'CategoryId')
            this.selectCategory()
            this.filterFaqList()
          }
        }
      )
    },
    filterFaqList() {
      if (this.selectedCategory && this.selectedCategory> 0){
        this.filteredFaqList = this.faqList[this.selectedCategory]
      } else if (this.selectedParentCategory && this.selectedParentCategory > 0) {
        this.filteredFaqList = this.faqListByParentCategory[this.selectedParentCategory]
      } else {
        this.filteredFaqList = []
      }
      /* var vm = this
      if (vm.selectedCategory && vm.selectedCategory > 0) {
        vm.filteredFaqList = lodash.filter(vm.faqList, function (item) {
          return item.CategoryId === vm.selectedCategory
        })
      } */
    },
    clearOnClick() {
      this.selectedcategory.Id = 0
      this.searchText = ''
      this.fetchFAQList()
    },
    selectCategory() {
      var vm = this
      if (this.$route.params.categoryId && this.$route.params.categoryId > 0) {
        this.setSelectedParentCategory(parseInt(this.$route.params.categoryId))
        // this.selectedParentCategory = this.$route.params.categoryId
      } else {
        this.selectedParentCategory = this.categorylist[0].Id
      }
      var faqDisplayProperty = window.getComputedStyle(this.$refs['faq-list-display']).display
      if (this.$route.params.categoryId) {
        if (vm.$refs['faq-cat-tab-' + this.$route.params.categoryId]) {
          vm.$refs['faq-cat-tab-' + this.$route.params.categoryId][0].click()
        }
        if (vm.$refs['accordion-btn-' + this.$route.params.categoryId]) {
          vm.$refs['accordion-btn-' + this.$route.params.categoryId][0].click()
        }
        if (vm.$route.params.faqId) {
          var elementOffset = 0
          setTimeout(function () {
            if (vm.$refs['faq-' + vm.$route.params.faqId] && faqDisplayProperty !== 'none') {
              elementOffset = vm.$refs['faq-' + vm.$route.params.faqId][0].offsetTop
              vm.$refs['faq-inner-' + vm.$route.params.faqId][0].click()
            }
            if (vm.$refs['faq-acc-' + vm.$route.params.faqId] && faqDisplayProperty === 'none') {
              elementOffset = vm.$refs['faq-acc-' + vm.$route.params.faqId][0].offsetTop
              vm.$refs['faq-acc-inner-' + vm.$route.params.faqId][0].click()
            }
            window.scrollTo({
              top: elementOffset,
              left: 0,
              behavior: 'smooth',
            })
          }, 150)
        }
      }
    },
    onTagClick(String) {
      this.$store.dispatch('chnageSearchString', String)
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    },
    setSelectedCategory (categoryId) {
      this.selectedCategory = categoryId
      this.filterFaqList()
    },
    setSelectedParentCategory (categoryId) {
      this.selectedParentCategory = categoryId
      this.selectedCategory = 0
      this.filterFaqList()
    }
  },
}
</script>
